import { Button, Card, CardTitle, Chip } from '@/ui/primitives';
import { formatRelative } from '@/lib/format';
import { useEndOtherSessions, useSessions } from '../api';

interface Props {
  userId: string;
}

function detectBrowser(ua: string): string {
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\//.test(ua)) return 'Opera';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Navegador';
}

function detectDevice(ua: string): string {
  if (/Mobi|Android|iPhone|iPad/.test(ua)) return 'Mobile';
  return 'Desktop';
}

export function SessoesAtivas({ userId }: Props) {
  const { data, isLoading, error } = useSessions(userId);
  const endOthers = useEndOtherSessions(userId);

  const otherCount = (data ?? []).filter((s) => !s.is_current).length;

  return (
    <Card padding="lg">
      <div className="flex items-center justify-between mb-3">
        <CardTitle>Sessões ativas</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          disabled={otherCount === 0 || endOthers.isPending}
          onClick={() => endOthers.mutate()}
        >
          {endOthers.isPending ? 'Encerrando…' : 'Encerrar outras sessões'}
        </Button>
      </div>

      {isLoading && <p className="text-xs text-text-muted">Carregando sessões…</p>}
      {error && <p className="text-xs text-danger">Falha ao carregar sessões.</p>}

      {data && data.length > 0 && (
        <ul className="flex flex-col divide-y divide-border">
          {data.map((s, i) => (
            <li key={`${s.created_at}-${i}`} className="py-3 flex items-center justify-between gap-3">
              <div className="flex flex-col gap-0.5 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-text">{detectBrowser(s.ua)}</span>
                  <Chip tone="neutral" size="sm">
                    {detectDevice(s.ua)}
                  </Chip>
                  {s.is_current && (
                    <Chip tone="ok" size="sm">
                      Atual
                    </Chip>
                  )}
                </div>
                <span className="text-xs text-text-muted truncate">
                  IP {s.ip} · iniciada {formatRelative(s.created_at)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
